
require('./setupMarionetteApp.js');

window.RivalIQ = window.createBackboneMarionetteApp();
